import { atomWithStorage } from "jotai/utils";
import { EssentialOverrides } from "../types";

/**
 * Per-item essential / discretionary classification, keyed by budget_id. Only
 * holds items the user has explicitly reclassified; everything else falls back
 * to the item's own flag (and defaults to essential). Persisted in localStorage
 * until BudgetDataItem.is_essential is stored server-side.
 */
export const essentialOverridesAtom = atomWithStorage<EssentialOverrides>(
  "cashflow.essentialOverrides",
  {},
  undefined,
  { getOnInit: true },
);
